export const Image_Upload_Form_Check = (data, Image_Type) => {
  for (let key in data) {
    if (data[key] === undefined || data[key] === "") {
      return ["All Fields are Mandatory!"];
    }
  }

  if (Image_Type.length === null || Image_Type === "") {
    return ["All Fields are Mandatory!"];
  }
  return ["success"];
};

export const Image_Upload_Form_Model = {
  University_Id: "",
  universityfile: "",
};
